import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/cutting_table.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { CuttingTableEffects } from './state/cutting_table.effects';
import { SortableColumnModule } from '../../sortableColumn/sortableColumn.module';
import { CuttingTableEditShellComponent } from './containers/cutting_table-edit-shell/cutting_table-edit-shell.component';
import { CuttingTableListComponent } from './components/cutting_table-list/cutting_table-list.component';
import { CuttingTableEditComponent } from './components/cutting_table-edit/cutting_table-edit.component';
import { CuttingTableShellComponent } from './containers/cutting_table-shell/cutting_table-shell.component';



@NgModule({
  declarations: [
    CuttingTableShellComponent,
    CuttingTableEditShellComponent,
    CuttingTableListComponent,
    CuttingTableEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('cutting_tables', reducer),
    EffectsModule.forFeature([CuttingTableEffects]),
    SortableColumnModule
  ],
  exports: [
    CuttingTableListComponent,
    CuttingTableEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortableColumnModule
  ]
})
export class CuttingTableModule {
  constructor(
  ) {}
}
